var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm._t("header", [
        _c("div", { staticClass: "clearfix header" }, [
          _vm.title || _vm.subTitle
            ? _c("div", { staticClass: "pull-left title" }, [
                _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
                _vm.subTitle
                  ? _c("span", {
                      staticClass: "note",
                      domProps: { innerHTML: _vm._s(_vm.subTitle) }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm.$slots.tabs
            ? _c("div", { staticClass: "pull-left tabs" }, [_vm._t("tabs")], 2)
            : _vm._e(),
          _vm.$slots.extra
            ? _c(
                "div",
                { staticClass: "pull-right extra" },
                [_vm._t("extra")],
                2
              )
            : _vm._e()
        ])
      ]),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }